<template>
  <div class="relative h-screen flex justify-center items-center login-background" style="min-height: 600px">
    <div class="w-full max-w-sm px-2">
      <div class="logo mb-10">
        <img src="@/assets/logo.svg" />
      </div>

      <form class="px-8 pt-6 pb-8 mb-4" @submit="realizarLogin">
        <div v-if="mensajeError != ''" class="bg-red text-white px-4 py-2 mb-4">
          <strong>Ha ocurrido un error.</strong><br>
          <span class="block sm:inline">{{ mensajeError }}</span>
        </div>

        <div
          v-if="mensajeExito == 'pass_changed'"
          class="text-azuloscuro text-2xl text-left leading-7 mb-10 font-semibold"
        >
          Tu contraseña se ha restablecido correctamente.
          <br />¡Ya puedes entrar!
        </div>

        <div class="mb-4">
          <label class="block text-azulfondoclaro text-sm" for="email">Email</label>
          <input
            class="appearance-none bg-transparent border-b-2 w-full py-1 text-azuloscuro leading-tight"
            type="text"
            placeholder
            v-model="email"
          />
        </div>
        <div class="mb-6">
          <label class="block text-azulfondoclaro text-sm" for="password">Contraseña</label>
          <div class="form-input w-full pr-8 focus-within:shadow-outline relative field-wrapper">
          <input
            class="appearance-none bg-transparent w-full py-1 text-azuloscuro mb-3 leading-tight"
            :type="showPassword ? 'text' : 'password'"
            placeholder
            v-model="password"
          />
          <button type="button" class="cursor-pointer z-100 absolute right-0 top-0 bottom-0 ml-2" @click="toggleShowPassword()">
            <Zondicon v-if="!showPassword" icon="view-show" class="fill-current inline-block mr-1 text-black loader" style="width: 24px"/>
            <Zondicon v-else icon="view-hide" class="fill-current inline-block mr-1 text-black loader" style="width: 24px"/>
          </button>
          </div>
        </div>

        <div class="flex justify-between mt-20">
          <button
            class="bg-azuloscuro hover:bg-greenlight text-white py-2 px-4 rounded-full focus:outline-none w-full"
            type="submit"
            :class="{ 'hidden': datosCargados == false }"
          >Entrar</button>

          <button
            class="bg-gray-600 mr-2 text-sm font-semibold text-white py-2 px-4 rounded-full w-full"
            type="button"
            :class="{ 'hidden': datosCargados == true }"
          >Enviando datos...</button>
        </div>

        <div class="mt-6 text-center text-xs">
          <span class="text-gray-700 font-thin">¿Olvidaste tu contraseña?</span><br>
          <router-link
            to="/recovery"
            class="inline text-azulfondoclaro hover:text-blue-800"
          >Recupérala aquí</router-link>
        </div>
      </form>
    </div>
    <div class="absolute inset-x bottom-0 pb-8 text-center text-xs text-gray-900">
      Entrando aceptas el<br><a href="https://skillpills.es/presentacion/aviso-legal/" class="text-azulfondoclaro hover:text-blue-900">aviso legal</a>, la <a href="https://skillpills.es/presentacion/politica-privacidad/" class="text-azulfondoclaro hover:text-blue-900">política de privacidad</a>
      <br>y la <a href="https://skillpills.es/presentacion/politica-de-cookies/" class="text-azulfondoclaro hover:text-blue-900">política de cookies</a>
    </div>
  </div>
</template>

<script>
import Utilities from "@/plugins/Utilities.js";
import auth from "@/plugins/api/users/auth";
import setTitle from "../plugins/title";
import Zondicon from "vue-zondicons";
const Login = {
  name: "Login",
  layout: "",
  data: function() {
    return {
      datosCargados: true,
      mensajeExito: "",
      mensajeError: "",
      showPassword: false,
      email: "",
      password: ""
    };
  },
  components: {
    Zondicon
  },
  beforeMount: function() {
    if (sessionStorage.getItem("login_message")) {
      this.mensajeExito = sessionStorage.getItem("login_message");
      sessionStorage.setItem("login_message", "");
    }
  },
  methods: {
    toggleShowPassword () {
      this.showPassword = !this.showPassword
    },
    async realizarLogin(e) {
      e.preventDefault();

      this.datosCargados = false;
      this.mensajeExito = "";
      this.mensajeError = "";

      if (this.email != "" && this.password != "") {
        try {
          const response = await auth
            .login(this.email, this.password)
            .then(res => {
              sessionStorage.setItem("token", res.data.token);
              auth.markAsLogged(res.data.id);
              this.datosCargados = true;
              if (localStorage.getItem('has_completed_tutorial')) {
                this.$router.push({ name: 'home' })
              } else {
                this.$router.push({ name: "tutorial_step_1" });
              }
            });
        } catch (e) {
          this.datosCargados = true;
          if(e.message.includes("401")){
              this.mensajeError = "Email y/o Contraseña incorrectos";
          }else{
              this.mensajeError = "Hubo un problema";
          }
        }
      } else {
        this.datosCargados = true;
        this.mensajeError =
          "Debe llenar correctamente todos los campos para poder ingresar al sistema";
      }
    }
  },
  created () {
    setTitle('Acceder')
  }
};

export default Login;
</script>

<style>
@import "../assets/styles/style_login.css";
</style>
